<div class="main-container">
    <div class="header">
        <p class="Search">Search Products</p>
        <mat-icon (click)=" closeDialog() ">close</mat-icon>
    </div>
    <hr>
    <div class="search-bar">
        <mat-form-field class="sfull-width domain-input" appearance="outline">
            <mat-icon matPrefix><mat-icon>search</mat-icon></mat-icon>
            <input #input type="text" placeholder="Enter business type" matInput [formControl]="ecomMyControl"
                [matAutocomplete]="auto1" (ngModelChange)="getVal($event)"
                (click)="input.focus(); ecomMyControl.setValue('')" />
            <mat-autocomplete #auto1="matAutocomplete">
                <mat-option *ngFor="
                  let option of ecomFilteredOptions | async;
                  index as i
                " [value]="option.name" (click)="selectBusinessType(option)" (keyup.enter)="selectBusinessType(option)"
                    id="searchValue">
                    {{ option.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <hr>
    <div class="middle-container">
        <div class="middle" *ngFor="let product of productData">
            <!-- <mat-checkbox class="example-margin"  (click)="addProduct(productOption, product)" [checked]="addedProductIds.includes(product.itemId)" #productOption></mat-checkbox> -->
            <mat-checkbox class="example-margin" (change)="addProduct(productOption, product)"
                [checked]="addedProductIds.includes(product.itemId)" #productOption></mat-checkbox>
            <img *ngIf="product.itemImages?.[0]?.imgUrl" [src]="product?.itemImages[0]?.imgUrl" class="prod-img"
                alt="User uploaded image">
            <img *ngIf="!product.itemImages?.[0]?.imgUrl"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5GLRiruBbo9dQ85FU7cY9Mt9LCQvridJJV5472zMbU0ZzX6jNUPnnh3J5_UShU-2lWhg&usqp=CAU"
                class="prod-img" alt="Default image">
            <p class="prod-name">{{product.name}}</p>
            <hr>
        </div>
        <hr>
    </div>
    <hr>
    <div class="all-btns">
        <button class="cancel" (click)=" closeDialog() ">Cancel</button>
        <button class="done" (click)="doneProduct()">Done</button>
    </div>
</div>